module.exports = __webpack_public_path__ + "img/icon-document-add.0ac2d67b.svg";